import React, {useCallback} from "react";
import {css, cx} from "@panda/css";

import {priceFormat} from "@pg-mono/string-utils";

import {OSMGenericNearbyOffersMap} from "../../../maps/components/generic_nearby_offers/open_street_maps/OSMGenericNearbyOffers";
import {IMapOffer} from "../../../maps/types/IMapOffer";
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {Country} from "../../../region/types/Country";
import {ViewType} from "../../../view_type/ViewType";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {
    transformRecommendedOfferIntoMapOffer,
    transformRecommendedPropertyIntoMapOffer
} from "../../utils/multi_lead/application_multi_lead_transform_to_map_offer";
import {getApplicationMultiLeadRecommendedMapIcon} from "../../utils/multi_lead/get_application_multi_lead_recommended_map_icon";

const multiLeadMainOfferPin = require("../../../maps/images/pins/multi_lead_main_offer_pin.svg");
const multiLeadCheckedOfferPin = require("../../../maps/images/pins/multi_lead_checked_offer_pin.svg");

interface IProps {
    checkedList: number[];
    className?: string;
    viewType: ViewType | null;
    originalGeoPoint: {
        coordinates: [number, number];
    };
    originalCountry: Country;
    originalOfferLabel?: string | null;
    recommendations: IRecommendedOffer[] | IRecommendedProperty[];
    handlePinClick: (viewType: ViewType | null, recommendedItemID: number) => void;
    hoveredItemID: number | null;
    recommendationType: ApplicationMultiLeadRecommendationType;
    hidePrices: boolean;
    mainPropertyId?: number;
}

const RecommendedMapC: React.FC<IProps> = (props) => {
    const {
        originalGeoPoint: {coordinates: originCoordinates},
        originalCountry,
        hidePrices
    } = props;

    const getMarkerIcon = (offerId: number): string => {
        const isChecked = props.checkedList.includes(offerId);
        return getApplicationMultiLeadRecommendedMapIcon(isChecked);
    };

    const handleDesktopInfoWindowOpen = (recommendedItemID: number) => {
        props.handlePinClick(props.viewType, recommendedItemID);
    };

    const handleOriginalMarkerClick = props.mainPropertyId ? () => props.handlePinClick(props.viewType, props.mainPropertyId!) : undefined;

    const originalMarkerIcon = props.mainPropertyId && props.checkedList.includes(props.mainPropertyId) ? multiLeadCheckedOfferPin : multiLeadMainOfferPin;

    const getOffersData = () => {
        if (props.recommendationType === ApplicationMultiLeadRecommendationType.PROPERTY) {
            return props.recommendations.map((recommendation) => transformRecommendedPropertyIntoMapOffer(recommendation as IRecommendedProperty));
        }

        return props.recommendations.map((recommendation) => transformRecommendedOfferIntoMapOffer(recommendation as IRecommendedOffer));
    };

    const getMarkerLabel = useCallback(
        (_offerId: number, offer: IMapOffer) => {
            if (hidePrices) {
                return "";
            }
            return offer.price ? (priceFormat(offer.price) ?? "?") : "?";
        },
        [hidePrices]
    );

    return (
        <div className={cx(recommendedMapWrapperStyle, props.className)}>
            <OSMGenericNearbyOffersMap
                drawCircleAroundMarkers
                viewType={props.viewType}
                hoveredItemID={props.hoveredItemID}
                originalMarkerCoordinates={originCoordinates}
                offers={getOffersData()}
                getMarkerIcon={getMarkerIcon}
                getMarkerLabel={getMarkerLabel}
                originalMarkerLabel={props.originalOfferLabel}
                originalMarkerIcon={originalMarkerIcon}
                originalMarkerCountry={originalCountry}
                onDesktopInfoWindowOpen={handleDesktopInfoWindowOpen}
                onOriginalMarkerClick={handleOriginalMarkerClick}
            />
        </div>
    );
};

export const ApplicationMultiLeadSimpleRecommendationsMap = React.memo(RecommendedMapC);

const recommendedMapWrapperStyle = css({
    position: "relative",
    paddingTop: "100%",
    sm: {
        paddingTop: 0,
        height: "100%"
    },
    "@media (max-height: 840px) and (max-width: 768px)": {
        paddingTop: "35vh",
        "& .lazy-google-map-container": {
            maxHeight: "35vh"
        }
    }
});
import React, {useCallback} from "react";
import {css, cx} from "@panda/css";

import {priceFormat} from "@pg-mono/string-utils";

import {OSMGenericNearbyOffersMap} from "../../../maps/components/generic_nearby_offers/open_street_maps/OSMGenericNearbyOffers";
import {IMapOffer} from "../../../maps/types/IMapOffer";
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {Country} from "../../../region/types/Country";
import {ViewType} from "../../../view_type/ViewType";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {
    transformRecommendedOfferIntoMapOffer,
    transformRecommendedPropertyIntoMapOffer
} from "../../utils/multi_lead/application_multi_lead_transform_to_map_offer";
import {getApplicationMultiLeadRecommendedMapIcon} from "../../utils/multi_lead/get_application_multi_lead_recommended_map_icon";

const multiLeadMainOfferPin = require("../../../maps/images/pins/multi_lead_main_offer_pin.svg");
const multiLeadCheckedOfferPin = require("../../../maps/images/pins/multi_lead_checked_offer_pin.svg");

interface IProps {
    checkedList: number[];
    className?: string;
    viewType: ViewType | null;
    originalGeoPoint: {
        coordinates: [number, number];
    };
    originalCountry: Country;
    originalOfferLabel?: string | null;
    recommendations: IRecommendedOffer[] | IRecommendedProperty[];
    handlePinClick: (viewType: ViewType | null, recommendedItemID: number) => void;
    hoveredItemID: number | null;
    recommendationType: ApplicationMultiLeadRecommendationType;
    hidePrices: boolean;
    mainPropertyId?: number;
}

const RecommendedMapC: React.FC<IProps> = (props) => {
    const {
        originalGeoPoint: {coordinates: originCoordinates},
        originalCountry,
        hidePrices
    } = props;

    const getMarkerIcon = (offerId: number): string => {
        const isChecked = props.checkedList.includes(offerId);
        return getApplicationMultiLeadRecommendedMapIcon(isChecked);
    };

    const handleDesktopInfoWindowOpen = (recommendedItemID: number) => {
        props.handlePinClick(props.viewType, recommendedItemID);
    };

    const handleOriginalMarkerClick = props.mainPropertyId ? () => props.handlePinClick(props.viewType, props.mainPropertyId!) : undefined;

    const originalMarkerIcon = props.mainPropertyId && props.checkedList.includes(props.mainPropertyId) ? multiLeadCheckedOfferPin : multiLeadMainOfferPin;

    const getOffersData = () => {
        if (props.recommendationType === ApplicationMultiLeadRecommendationType.PROPERTY) {
            return props.recommendations.map((recommendation) => transformRecommendedPropertyIntoMapOffer(recommendation as IRecommendedProperty));
        }

        return props.recommendations.map((recommendation) => transformRecommendedOfferIntoMapOffer(recommendation as IRecommendedOffer));
    };

    const getMarkerLabel = useCallback(
        (_offerId: number, offer: IMapOffer) => {
            if (hidePrices) {
                return "";
            }
            return offer.price ? (priceFormat(offer.price) ?? "?") : "?";
        },
        [hidePrices]
    );

    return (
        <div className={cx(recommendedMapWrapperStyle, props.className)}>
            <OSMGenericNearbyOffersMap
                drawCircleAroundMarkers
                viewType={props.viewType}
                hoveredItemID={props.hoveredItemID}
                originalMarkerCoordinates={originCoordinates}
                offers={getOffersData()}
                getMarkerIcon={getMarkerIcon}
                getMarkerLabel={getMarkerLabel}
                originalMarkerLabel={props.originalOfferLabel}
                originalMarkerIcon={originalMarkerIcon}
                originalMarkerCountry={originalCountry}
                onDesktopInfoWindowOpen={handleDesktopInfoWindowOpen}
                onOriginalMarkerClick={handleOriginalMarkerClick}
            />
        </div>
    );
};

export const ApplicationMultiLeadSimpleRecommendationsMap = React.memo(RecommendedMapC);

const recommendedMapWrapperStyle = css({
    position: "relative",
    paddingTop: "100%",
    sm: {
        paddingTop: 0,
        height: "100%"
    },
    "@media (max-height: 840px) and (max-width: 768px)": {
        paddingTop: "35vh",
        "& .lazy-google-map-container": {
            maxHeight: "35vh"
        }
    }
});
